/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档



export interface API76854Req {
  
  /** 任务节点id */
  bizNo: string;
};



export type API76854Res = {};


// 接口函数 76854 任务节点自动拆分

export interface IUsePostAPI76854Return {
  /** 任务节点自动拆分: 接口请求状态 */
  isAPI76854Loading: boolean;
  /** 任务节点自动拆分: 接口请求返回数据 */
  dataAPI76854: API76854Res;
  /**  任务节点自动拆分: 接口数据请求方法 */
  fetchAPI76854Data: (inputs: API76854Req, config?: YWRequestConfig) => Promise<API76854Res>;
  /** 任务节点自动拆分: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI76854 = ():IUsePostAPI76854Return => {
  let isMount = true;
  const [isAPI76854Loading, setIsAPI76854Loading] = useState(false);
  const [dataAPI76854, setDataAPI76854] = useState<API76854Res>({} as API76854Res);
  const requestUrl = `${basePath}/yoaichat-web/task/instance/split/node`;

  const fetchAPI76854Data = async (inputs: API76854Req, config?: YWRequestConfig): Promise<API76854Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API76854Req>) || {}) as API76854Req;
    
  
    if ( isMount ) {
      setIsAPI76854Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API76854Res>(`${basePath}/yoaichat-web/task/instance/split/node`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI76854(res || {} as API76854Res);
        setIsAPI76854Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76854Loading(false);
      }
      return false as unknown as API76854Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76854Loading,
    dataAPI76854,
    fetchAPI76854Data,
    requestUrl,
  }
}

